export default class FUmkm {
  constructor(
    id = 0,
    kode1 ="", //Dijadikan NIB
    kode1Valid,
    lastValidate,
    merk ="",
    merkValid,
    merkValidateAt,
    namaPemilik  ="",
    description = "",
    fdivisionBean = 0,
    statusActive =true,
    avatarImage = "" ,
    fumkmTypeBean = 0,
    address = "",
    fsubAreaBean = 0,

    notes ="",
    needs = "",
    tanggalBerdiri,
    jumlahKaryawan = 0,
    emplMale,
    emplFemale,

    lat = 0.0,
    lon = 0.0,

    itemsPermit= [],
    omset = 0.0,
    modal,
    lapKeuangan = false,
    userBean = 0,

    namaBadanUsaha = "",

    created,
    modified,
    modifiedBy

  ) {
    this.id = id;
    this.kode1 = kode1;
    this.kode1Valid = kode1Valid;
    this.lastValidate = lastValidate;
    this.merk = merk;
    this.merkValid = merkValid;
    this.merkValidateAt = merkValidateAt;
    this.namaPemilik = namaPemilik;
    this.description = description;
    this.fdivisionBean = fdivisionBean;
    this.statusActive = statusActive;
    this.avatarImage = avatarImage;
    this.fumkmTypeBean = fumkmTypeBean;
    this.fsubAreaBean = fsubAreaBean;
    this.address = address;

    this.notes = notes;
    this.needs = needs;
    this.tanggalBerdiri = tanggalBerdiri;
    this.jumlahKaryawan = jumlahKaryawan;
    this.emplMale = emplMale;
    this.emplFemale = emplFemale;

    this.lat = lat;
    this.lon = lon;

    this.itemsPermit = itemsPermit;
    this.omset = omset;
    this.modal = modal;
    this.lapKeuangan = lapKeuangan;

    this.userBean = userBean;

    this.namaBadanUsaha = namaBadanUsaha;

    this.created = created;
    this.modified = modified;
    this.modifiedBy = modifiedBy;
  }

}
